module.exports = __webpack_public_path__ + "assets/img/zh6.07a9e510.png";